(function () {
  'use strict';

  /* Révision 11/09/2026 (L'ARCHITECTE 9). Un seul ajout de comportement, mesuré au préalable :
     au repli ("Voir moins"), la grille perdait ~670 px de hauteur d'un coup et le script ne
     gérait pas la position de lecture. Un utilisateur descendu regarder les photos se retrouvait
     face à du contenu qui avait sauté, sans le bouton en vue. Désormais, si l'ancre du bouton
     est sortie de l'écran au moment du repli, on la ramène en vue par un défilement doux
     (immédiat sous prefers-reduced-motion). Rien d'autre ne change. */

  if (window.__efaProductGalleryDisclosure) return;
  window.__efaProductGalleryDisclosure = true;

  var GRID_SELECTOR = '.l4pr:not(.slider):not(.s4wi):not(.mobile-only)';
  var BUTTON_SELECTOR = '[data-efa-gallery-button]';
  var HOST_SELECTOR = '[data-efa-gallery-toggle]';
  var OPEN_CLASS = 'efa-gallery-expanded';
  var frame = 0;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resetPosition(host) {
    host.style.setProperty('--efa-gallery-shift-x', '0px');
    host.style.setProperty('--efa-gallery-shift-y', '0px');
    host.classList.remove('is-positioned');
  }

  function positionToggle(grid) {
    var host = grid.querySelector(HOST_SELECTOR);
    if (!host) return;

    resetPosition(host);
    if (!grid.classList.contains(OPEN_CLASS)) return;

    var anchor = host.parentElement;
    if (!anchor) return;

    var gridRect = grid.getBoundingClientRect();
    var anchorRect = anchor.getBoundingClientRect();
    var shiftX = gridRect.left + gridRect.width / 2 - (anchorRect.left + anchorRect.width / 2);
    var shiftY = gridRect.bottom - anchorRect.bottom;

    if (!Number.isFinite(shiftX) || !Number.isFinite(shiftY)) return;

    host.style.setProperty('--efa-gallery-shift-x', shiftX.toFixed(2) + 'px');
    host.style.setProperty('--efa-gallery-shift-y', shiftY.toFixed(2) + 'px');
    host.classList.add('is-positioned');
  }

  function positionOpenGalleries() {
    document.querySelectorAll(GRID_SELECTOR + '.' + OPEN_CLASS).forEach(positionToggle);
  }

  function schedulePosition() {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        positionOpenGalleries();
      });
    });
  }

  /* Au repli : si l'ancre du bouton (le 4e media) est passee au-dessus de l'ecran,
     on la ramene en bas de la fenetre, pour que l'utilisateur retrouve le bouton
     qu'il vient de cliquer et la fin des photos visibles. */
  function keepAnchorInView(host) {
    var anchor = host.parentElement;
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom < 0 || rect.top > viewportH) {
      anchor.scrollIntoView({ block: 'end', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }
  }

  function hydrate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var grid = button.closest('.l4pr');
      if (grid && grid.id) button.setAttribute('aria-controls', grid.id);
    });
  }

  function setExpanded(button, expanded) {
    var host = button.closest(HOST_SELECTOR);
    var grid = host && host.closest(GRID_SELECTOR);
    if (!host || !grid) return;

    if (grid.id) button.setAttribute('aria-controls', grid.id);
    grid.classList.toggle(OPEN_CLASS, expanded);
    host.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (expanded) {
      resetPosition(host);
      schedulePosition();
    } else {
      resetPosition(host);
      keepAnchorInView(host);
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    var host = button.closest(HOST_SELECTOR);
    var grid = host && host.closest(GRID_SELECTOR);
    if (!grid) return;

    event.preventDefault();
    event.stopPropagation();
    setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
  });

  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('orientationchange', schedulePosition, { passive: true });

  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLImageElement && event.target.closest(GRID_SELECTOR + '.' + OPEN_CLASS)) {
      schedulePosition();
    }
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    hydrate(event.target);
    schedulePosition();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(document); }, { once: true });
  } else {
    hydrate(document);
  }
})();


/* ============================================================================
   EFA - GALERIE PRODUIT MOBILE : boucle, barre + fraction, teinte, swipe.
   L'ARCHITECTE 9, 14/09/2026, sur les trois defauts signales par Timothee.

   POURQUOI ICI. Ce fichier est deja charge par sections/main-product.liquid (L4,
   defer) sur toutes les fiches : aucune requete ajoutee, aucune ligne de Liquid a
   toucher, et le CSS part dans efa-product-gallery.css, charge L3. assets/custom.js
   (coeur du theme) n'est pas modifie : on REPREND l'instance qu'il cree.

   1. « la barre s'arrete a 5 sur mon telephone, 8 au minimum desktop ». Ce n'est pas
      un JS peu rigoureux : Swiper rend bien 8 vignettes, mais le theme les MASQUE par
      paliers de largeur (page-product.css : .swiper-pagination-bullet:nth-child(n+7)
      {display:none} sous 400 px, n+6 sous 350...). Des vignettes de 36 px alignees :
      le compte ne peut jamais suivre le nombre de photos. On remplace la pagination
      par une BARRE DE PROGRESSION native de Swiper (largeur = (index+1)/total) et une
      FRACTION « 01 / 08 ». Le total est capture AVANT la reprise, donc jamais fausse
      par les slides de boucle.
   2. « arrive a la derniere image on ne peut plus scroll a droite ; l'ideal serait que
      ca loop dans les deux sens ». Le theme pose loop:false, sans rewind. On repasse la
      meme instance en loop (rewind si 2 photos seulement, ou le loop n'est pas permis).
   3. « la barre et le chiffre passent en blanc si le bg est sombre... dynamiquement
      d'une photo a l'autre ». On echantillonne la bande basse de l'image active (canvas
      24x3, meme origine CDN), luminance WCAG, seuil 0,2004 (point ou blanc et #191919
      donnent le meme contraste, 4,19:1). Un seul calcul par src, en cache, apres
      decode(), jamais si l'image n'est pas chargee. Canvas teinte -> on renonce.
   4. LE SWIPE (cause 2 sur 2 ; la cause 1 est dans le CSS, voir efa-product-gallery.css).
      MESURE au banc tactile reel : avec longSwipesRatio 0,5, tout glissement juge
      « long » (> 300 ms) devait depasser 50 % de la largeur, soit 187 px a 375 px.
      Matrice : 100, 150 et 200 px echouaient TOUS, quelle que soit la duree ; 240 px
      passait. A 0,2 : 100, 150, 200 px passent, 80 echoue. Un demi-ecran glisse suffit.

   COUT : ~2,9 Ko sans commentaires, 0 dependance, 0 requete, aucun minuteur (un seul
   MutationObserver sur la section, rappel O(1)). lazyPreloadPrevNext:1 charge la voisine
   de chaque cote - 2 images de plus au chargement, et c'est ce qui evite l'image blanche
   quand on revient sur la derniere photo par la gauche.
   ============================================================================ */
(function () {
  'use strict';

  var SEUIL = 0.2004;
  var ul0 = document.getElementById('main-product-slider');
  if (!ul0 || !(ul0.getAttribute('data-media-size') > 1)) return;
  var sec = ul0.closest('.shopify-section') || document.body;
  var cache = {}, ctx, mort = false;

  function lin(c) { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function poser(ul, img, sombre) { if (ul.efaImg === img) ul.classList.toggle('is-dark', sombre); }

  function teinte(ul, img) {
    var src = img.currentSrc || img.src, v = cache[src];
    if (mort || !src) return;
    if (v !== undefined) { if (v !== null) poser(ul, img, v); return; }
    if (!img.complete) { img.addEventListener('load', function () { teinte(ul, img); }, { once: true }); return; }
    cache[src] = null;
    (img.decode ? img.decode() : Promise.resolve()).then(function () {
      var w = img.naturalWidth, h = img.naturalHeight, d, i, s = 0;
      if (!w || !h) { delete cache[src]; return; }
      ctx = ctx || document.createElement('canvas').getContext('2d', { willReadFrequently: true });
      ctx.canvas.width = 24; ctx.canvas.height = 3;
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, 24, 3);
      ctx.drawImage(img, 0, h * 0.88, w, h * 0.12, 0, 0, 24, 3);
      d = ctx.getImageData(0, 0, 24, 3).data;
      for (i = 0; i < d.length; i += 4) s += 0.2126 * lin(d[i]) + 0.7152 * lin(d[i + 1]) + 0.0722 * lin(d[i + 2]);
      cache[src] = s / (d.length / 4) < SEUIL;
      poser(ul, img, cache[src]);
    })['catch'](function (e) {
      delete cache[src];
      if (e && e.name === 'SecurityError') mort = true;
    });
  }

  function prendre(ul) {
    var outer = ul.querySelector('.swiper-outer'), old = outer && outer.swiper, cont, num, sw;
    if (!old || old.efaGal || !outer.clientWidth) return;
    cont = ul.querySelector('.swiper-custom-bullets');
    if (!cont) return;

    var Ctor = old.constructor;
    var total = old.slides.length;
    var depart = old.realIndex;
    var base = Object.assign({}, old.passedParams);
    var p = Object.assign({}, base);
    p.pagination = Object.assign({}, base.pagination, { type: 'progressbar', clickable: false });
    p.loop = total > 2;
    p.rewind = !p.loop;
    p.initialSlide = depart;
    p.longSwipesRatio = 0.2;
    p.lazyPreloadPrevNext = 1;

    num = cont.querySelector('.efa-gal__num');
    if (!num) { num = document.createElement('span'); num.className = 'efa-gal__num'; cont.appendChild(num); }

    function maj(s) {
      var slide = s.slides[s.activeIndex], img = slide && slide.querySelector('img');
      num.textContent = pad(s.realIndex + 1) + ' / ' + pad(total);
      ul.efaImg = img;
      if (img) teinte(ul, img);
    }
    p.on = Object.assign({}, base.on, { paginationUpdate: maj, slideChange: maj });

    old.destroy(true, true);
    ul.classList.add('efa-gal');
    try {
      sw = new Ctor(outer, p);
    } catch (e) {
      ul.classList.remove('efa-gal');
      try { new Ctor(outer, base); } catch (e2) {}
      return;
    }
    sw.efaGal = true;
    maj(sw);
  }

  function tenter() {
    var ul = document.getElementById('main-product-slider');
    if (ul && ul.classList.contains('mobile-only')) prendre(ul);
  }

  new MutationObserver(tenter).observe(sec, { childList: true, subtree: true });
  tenter();
})();
